import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PageHeader } from "@/app/PageHeader";
import { useAuth } from "@/features/auth/AuthContext";
import { ErrorState } from "@/features/devices/components/ErrorState";
import { SecaoPessoas } from "@/features/users/SecaoPessoas";
import { NavigationSettings } from "@/features/navigation/NavigationSettings";

/**
 * Configurações da instalação.
 *
 * Organiza areas/equipamentos e pessoas sem misturar cadastro com navegacao.
 *
 * A página existe só para quem tem algo a configurar. Hoje isso significa
 * `admin`; quando houver preferência PESSOAL — que todo mundo ajusta —, a
 * guarda muda para "tem pelo menos uma seção visível" em vez de um papel.
 */
export function ConfiguracoesPage() {
  const { permissoes, aberto, usuario } = useAuth();
  const { hash } = useLocation();
  const canOrganize = !aberto && permissoes.gerenciarWorkspaces;
  useEffect(() => {
    if (hash === "#navegacao" && canOrganize) document.getElementById("navegacao")?.scrollIntoView?.({ block: "start" });
  }, [hash, canOrganize]);

  if (!permissoes.gerenciarPessoas && !canOrganize) {
    return (
      <div className="content">
        <ErrorState
          title="Nada para configurar por aqui"
          message="As configurações desta tela são da organização, e só quem a administra pode mexer nelas."
        />
      </div>
    );
  }

  return (
    <>
      <PageHeader
        crumbs={[{ label: "Dashboard", to: "/workflows" }, { label: "Configurações" }]}
        title="Configurações"
      />
      <div className="content">
        {canOrganize ? <NavigationSettings key={`${usuario?.id}/${usuario?.organizacao?.organizationId}`} /> : null}
        {permissoes.gerenciarPessoas ? <SecaoPessoas /> : null}
      </div>
    </>
  );
}
